import React, { useContext } from "react";
import { NavLink, generatePath } from "react-router-dom";

import { Image, Link, ImageProps } from "@chakra-ui/react";

import config from "config/config";
import { PAGE_PATHS } from "config/routes";
import { TrackingContext } from "contexts";
import { getMyProfile } from "hooks/api/userProfiles/useFetchMyProfile/useFetchMyProfile";
import { useTrackEvent } from "utils/tracking/hooks";

const {
  brand: { general, plus },
} = config;

type IComponent = ImageProps;

const DashboardLogoLink: React.FC<IComponent> = ({ ...props }) => {
  const { subPageType } = useContext(TrackingContext);
  const userProfile = getMyProfile();

  const { trackCtaClick } = useTrackEvent();

  const onClick = () => {
    trackCtaClick("ahp logo", subPageType);
  };

  const logoType = userProfile?.policy.coverage?.active ? plus : general;

  return (
    <Link as={NavLink} to={generatePath(PAGE_PATHS.HOME_PAGE)} onClick={onClick}>
      <Image
        src={logoType.logo.path}
        w={logoType.logo.width}
        h="auto"
        loading="lazy"
        alt=""
        data-testid="airhelp-logo"
        {...props}
      />
    </Link>
  );
};

export default DashboardLogoLink;
